import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [{
		name: 'index',
		path: '/',
		component: (resolve) => require(['@/components/Index'], resolve),
		meta: {
			is_login: true,
			name: '首页'
		}
	}, {
		name: 'login',
		path: '/login',
		component: (resolve) => require(['@/components/Login'], resolve),
		meta: {
			is_login: false,
			name: '登录'
		}
	}, {
		name: 'reg',
		path: '/reg',
		component: (resolve) => require(['@/components/Reg'], resolve),
		meta: {
			is_login: false,
			name: '注册'
		}
	}, {
		name: 'forget',
		path: '/forget',
		component: (resolve) => require(['@/components/Forget'], resolve),
		meta: {
			is_login: false,
			name: '忘记密码'
		}
	}, {
		name: 'app',
		path: '/app',
		component: (resolve) => require(['@/components/app/Index'], resolve),
		meta: {
			is_login: true,
			name: '应用列表'
		}
	}, {
		name: 'app_edit',
		path: '/app/edit',
		component: (resolve) => require(['@/components/app/Edit'], resolve),
		meta: {
			is_login: true,
			name: '修改应用'
		}
	}, {
		name: 'app_add',
		path: '/app/add',
		component: (resolve) => require(['@/components/app/Edit'], resolve),
		meta: {
			is_login: true,
			name: '新增应用'
		}
	}, {
		name: 'cdk',
		path: '/cdk',
		component: (resolve) => require(['@/components/cdk/Index'], resolve),
		meta: {
			is_login: true,
			name: '卡密列表'
		}
	}, {
		name: 'cdk_add',
		path: '/cdk/add',
		component: (resolve) => require(['@/components/cdk/Edit'], resolve),
		meta: {
			is_login: true,
			name: '创建卡密'
		}
	}, {
		name: 'auth',
		path: '/auth',
		component: (resolve) => require(['@/components/auth/Index'], resolve),
		meta: {
			is_login: true,
			name: '授权列表'
		}
	}, {
		name: 'auth_add',
		path: '/auth/add',
		component: (resolve) => require(['@/components/auth/Edit'], resolve),
		meta: {
			is_login: true,
			name: '创建授权'
		}
	}, {
		name: 'auth_edit',
		path: '/auth/edit',
		component: (resolve) => require(['@/components/auth/Edit'], resolve),
		meta: {
			is_login: true,
			name: '编辑授权'
		}
	}, {
		name: 'version',
		path: '/version',
		component: (resolve) => require(['@/components/version/Index'], resolve),
		meta: {
			is_login: true,
			name: '版本列表'
		}
	}, {
		name: 'version_add',
		path: '/version/add',
		component: (resolve) => require(['@/components/version/Edit'], resolve),
		meta: {
			is_login: true,
			name: '创建版本'
		}
	}, {
		name: 'version_edit',
		path: '/version/edit',
		component: (resolve) => require(['@/components/version/Edit'], resolve),
		meta: {
			is_login: true,
			name: '编辑版本'
		}
	}, {
		name: 'variable',
		path: '/variable',
		component: (resolve) => require(['@/components/variable/Index'], resolve),
		meta: {
			is_login: true,
			name: '远程变量'
		}
	}, {
		name: 'variable_add',
		path: '/variable/add',
		component: (resolve) => require(['@/components/variable/Edit'], resolve),
		meta: {
			is_login: true,
			name: '创建变量'
		}
	}, {
		name: 'variable_edit',
		path: '/variable/edit',
		component: (resolve) => require(['@/components/variable/Edit'], resolve),
		meta: {
			is_login: true,
			name: '编辑变量'
		}
	},{
		name: 'auth_log',
		path: '/auth/log',
		component: (resolve) => require(['@/components/auth/Log'], resolve),
		meta: {
			is_login: true,
			name: '授权日志'
		}
	},{
		name: 'agent_type',
		path: '/agent_type',
		component: (resolve) => require(['@/components/agent_type/Index'], resolve),
		meta: {
			is_login: true,
			name: '代理等级'
		}
	}, {
		name: 'agent_type_add',
		path: '/agent_type/add',
		component: (resolve) => require(['@/components/agent_type/Edit'], resolve),
		meta: {
			is_login: true,
			name: '代理等级'
		}
	}, {
		name: 'agent_type_edit',
		path: '/agent_type/edit',
		component: (resolve) => require(['@/components/agent_type/Edit'], resolve),
		meta: {
			is_login: true,
			name: '代理等级'
		}
	},{
		name: 'cdk_spec',
		path: '/cdk_spec',
		component: (resolve) => require(['@/components/cdk_spec/Index'], resolve),
		meta: {
			is_login: true,
			name: '卡密套餐'
		}
	}, {
		name: 'cdk_spec_add',
		path: '/cdk_spec/add',
		component: (resolve) => require(['@/components/cdk_spec/Edit'], resolve),
		meta: {
			is_login: true,
			name: '卡密套餐'
		}
	}, {
		name: 'cdk_spec_edit',
		path: '/cdk_spec/edit',
		component: (resolve) => require(['@/components/cdk_spec/Edit'], resolve),
		meta: {
			is_login: true,
			name: '卡密套餐'
		}
	},{
		name: 'agent',
		path: '/agent',
		component: (resolve) => require(['@/components/agent/Index'], resolve),
		meta: {
			is_login: true,
			name: '代理商列表'
		}
	}, {
		name: 'agent_add',
		path: '/agent/add',
		component: (resolve) => require(['@/components/agent/Edit'], resolve),
		meta: {
			is_login: true,
			name: '代理商列表'
		}
	}, {
		name: 'agent_edit',
		path: '/agent/edit',
		component: (resolve) => require(['@/components/agent/Edit'], resolve),
		meta: {
			is_login: true,
			name: '代理商列表'
		}
	},{
		name: 'log_auth',
		path: '/log/auth',
		component: (resolve) => require(['@/components/log/Auth'], resolve),
		meta: {
			is_login: true,
			name: '授权日志'
		}
	},{
		name: 'log_cdk',
		path: '/log/cdk',
		component: (resolve) => require(['@/components/log/Cdk'], resolve),
		meta: {
			is_login: true,
			name: '提卡日志'
		}
	},{
		name: 'log_amount',
		path: '/log/amount',
		component: (resolve) => require(['@/components/log/Amount'], resolve),
		meta: {
			is_login: true,
			name: '资金日志'
		}
	}, {
		name: 'update',
		path: '/update',
		component: (resolve) => require(['@/components/update/Index'], resolve),
		meta: {
			is_login: true,
			name: '更新日志'
		}
	},{
		name: 'program',
		path: '/program',
		component: (resolve) => require(['@/components/program/Index'], resolve),
		meta: {
			is_login: true,
			name: 'APP&小程序'
		}
	},{
		name: 'vip',
		path: '/vip',
		component: (resolve) => require(['@/components/vip/Index'], resolve),
		meta: {
			is_login: true,
			name: '开通服务'
		}
	},{
		name: 'package',
		path: '/vip/package',
		component: (resolve) => require(['@/components/vip/Package'], resolve),
		meta: {
			is_login: true,
			name: '扩展包'
		}
	}, {
		name: 'download',
		path: '/download',
		component: (resolve) => require(['@/components/download/Index'], resolve),
		meta: {
			is_login: true,
			name: '下载中心'
		}
	}]
})



// WEBPACK FOOTER //
// ./src/router/index.js